import React from "react";
import * as Elements from "./elements.js";

function LoadingPage() {
	return (
		<Elements.Container>
			<Elements.Spinner>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</Elements.Spinner>
		</Elements.Container>
	);
}

export default LoadingPage;
